import { BindedModelBase, bindedModelBase } from '@ortho-next/nextray-core';

/**
 * Model used by three.js part to create 3d objects binding.
 */
export class BindedModel extends BindedModelBase {
}

export const bindedModel: BindedModel = bindedModelBase;
